(function ($) {
  $(function () {
    // Function to scroll smoothly to the element
    function smoothScrollToHash(hash) {
      var target = $(hash);
      if (target.length) {
        $('html, body').animate(
          { scrollTop: target.offset().top - 100 },
          800 // Duration in milliseconds
        );
      }
    }

    // Scroll on page load if there's a hash in the URL
    if (window.location.hash) {
      smoothScrollToHash(window.location.hash);
    }

    // Smooth scrolling when clicking anchor links
    $('a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      var hash = this.hash;
      if (hash) {
        smoothScrollToHash(hash);
        history.pushState(null, null, hash); // Update URL without reloading
      }
    });
  });

  //To match the column heights in a column block
  $(window).on('load resize', function () {
    matchHeights();
  });

  function matchHeights() {
    const $textCol = $('.col-1');
    const $imgCol = $('.col-2');

    if ($textCol.length && $imgCol.length) {
      $imgCol.height($textCol.outerHeight());
    }
  }
})(jQuery);

//To match the column heights in a column block
// window.addEventListener('load', matchHeights);
// window.addEventListener('resize', matchHeights);

// function matchHeights() {
//   const textCol = document.querySelector('.col-1');
//   const imgCol = document.querySelector('.col-2');
//   if (textCol && imgCol) {
//     imgCol.style.height = textCol.offsetHeight + 'px';
//   }
// }
